import React from "react";
import { MenuItem, Select, SelectChangeEvent, ThemeProvider, createTheme } from "@mui/material";
import ChevronDownIcon from "../../assets/icons/ChevronDownIcon";
import useTranslation from "../../../shared/hooks/useTranslation";

export interface TablePageSizeSelectProps {
  value: number;
  onChange: (value: number) => void;
}

const colorVioletDark = "#332B41";
const colorWhite = "#FFF";
const colorBlue96 = "#F3F5F8";

const TablePageSizeSelect = ({ value, onChange }: TablePageSizeSelectProps) => {
  const { translate: tCommon } = useTranslation("common");

  const handleChange = (event: SelectChangeEvent) => {
    onChange(Number(event.target.value));
  };

  const theme = createTheme({
    components: {
      MuiSelect: {
        styleOverrides: {
          root: {
            backgroundColor: colorVioletDark,
            color: colorWhite,
            height: "28px !important"
          },
          select: {
            padding: "4px 26px 4px 10px !important"
          },
          icon: {
            color: `${colorWhite} !important`,
            stroke: `${colorWhite} !important`,
            top: "8px",
            right: "10px",
            height: "12px",
            width: "12px",
          }
        }
      },
      MuiMenu: {
        styleOverrides: {
          list: {
            backgroundColor: colorVioletDark,
          }
        }
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            color: "#FFF",
            backgroundColor: colorVioletDark,
            height: "24px",
            "&.Mui-selected": {
              color: `${colorVioletDark} !important`,
              backgroundColor: `${colorBlue96} !important`
            },
            "&:hover": {
              color: `${colorVioletDark} !important`,
              backgroundColor: `${colorWhite} !important`
            },
          }
        }
      }
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <div className="flex items-center">
        <p className="text-12-regular">{tCommon("common.itemsPerPage")}</p>

        <div>
          <Select
            displayEmpty
            value={value.toString()}
            onChange={handleChange}
            className="ml-2"
            IconComponent={ChevronDownIcon}>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </div>
      </div>
    </ThemeProvider>
  )
}

export default TablePageSizeSelect;